import { z } from 'zod';

// Zod checks whether eval is available while creating object schemas. The
// application must load only after JIT has been disabled for the CSP.
z.config({ jitless: true });
await import('./main');
